import { useDispatch, useSelector } from "react-redux";
import { IRootReducer } from "store/reducers";
import { IUserState } from "./user.interface";
import { setUser, logout, setTheme, setLanguage } from "./user.action";
import { useCallback, useMemo } from "react";
import { getColorByMail } from "utils";

export interface IUserModel extends IUserState{
  setUser: Function;
  logout: Function;
  setTheme: Function;
  setLanguage: Function;
  getDatetime: Function;
  hasPermission: Function;
  color: any;
}

export default function UserModel(){
  const user = useSelector<IRootReducer,IUserState>(state => state.user);
  const dispatch = useDispatch();

  const getDatetime = useCallback(()=>{
    if(user.current_date){
      const [date, hours] = user.current_date.split(" ");
      const [Y,M,D] = date.split("-");
      const [h,m,s] = hours.split(":");

      return {
        year: parseInt(Y),
        month: parseInt(M),
        day: parseInt(D),
        hours: parseInt(h),
        minutes: parseInt(m),
        seconds: parseInt(s)
      };
    }
    return null;
  },[user.current_date]);

  const hasPermission = useCallback((permission:string) => {
    let index = user.permissions.indexOf(permission);
    return index !== -1;
  },[user.permissions]);

  const color = useMemo(() => {
    return getColorByMail(user.email);
  },[user.email]);

  const _retorno:IUserModel = {...user,...{
    setUser:(user: IUserState)=>{dispatch(setUser(user))},
    logout:()=>{dispatch(logout())},
    setTheme:(id: number,theme: string)=>{dispatch(setTheme(id,theme))},
    setLanguage:(id: number, language: string)=>{dispatch(setLanguage(id,language))},
    getDatetime,
    hasPermission,
    color
  }};

  return _retorno;
}